import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLessComponent } from './simple-icons-less.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLessComponent ],
    exports:      [ SimpleIconsLessComponent ],
    bootstrap:    []
})
export class SimpleIconsLessModule {}
